<template>
  <ListItem>
    <div class="flex items-start gap-x-3">
      <router-link :to="{ name: 'admin.config-requests.show', params: { id: configChangeRequest.id } }">
        <p class="text-sm font-semibold leading-6 text-surface-900 hover:underline">
          {{ configChangeRequest.title || `#${configChangeRequest.id}` }}
        </p>
      </router-link>
      <FlatBadge :color="statusColor" :value="statusLabel" class="mt-0.5"/>
    </div>

    <div class="mt-1 text-xs leading-5 text-surface-500">
      <div class="flex flex-row justify-between items-center space-x-2 w-full" v-if="showInitiatedBy || showInitiatedAt">
        <span class="text-surface-800 flex-1 font-medium" v-if="showInitiatedBy">
          {{ configChangeRequest.requested_by?.name || $t('common.na') }}
        </span>
        <span class="text-surface-400" v-if="showInitiatedAt">
          <time>{{ $d(Date.parse(configChangeRequest.created_at), 'long') }}</time>
        </span>
      </div>
    </div>
  </ListItem>
</template>

<script>
import ListItem from "@/Components/ListItem.vue";
import FlatBadge from "@/Components/Badges/FlatBadge.vue";

export default {
  name: "DevicesConfigUpdatesListItem",
  components: {
    FlatBadge,
    ListItem,
  },
  data() {
    return {
      statusLabels: {
        1: 'Requested',
        2: 'Approved',
        3: 'Rejected',
        4: 'Applied',
        5: 'Current',
      },
      statusColors: {
        1: 'blue',
        2: 'green',
        3: 'red',
        4: 'gray',
        5: 'indigo',
      },
    }
  },
  props: {
    configChangeRequest: {
      type: Object,
      required: true,
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    statusLabel() {
      return this.statusLabels[this.configChangeRequest.status] || 'Unknown';
    },
    statusColor() {
      return this.statusColors[this.configChangeRequest.status] || 'gray';
    },
  },
}
</script>

<style scoped>

</style>
